import { useTranslation } from 'react-i18next'

interface NotEligibleForPromotionMessageProps {
  onSeeOtherOfferings: () => void
}

export function NotEligibleForPromotionMessage({ onSeeOtherOfferings }: NotEligibleForPromotionMessageProps) {
  const { t } = useTranslation()

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-tr from-[#05155E] from-15% via-[#0163D0] to-[#4B97FE] p-4">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-lg shadow-lg overflow-hidden">
          <div className="bg-gradient-to-tr from-[#05155E] from-15% via-[#0163D0] to-[#4B97FE] p-9">
            <p className="text-center text-white text-[40px] font-black tracking-[-4px]">DUPR</p>
          </div>

          <div className="p-8">
            <div className="flex flex-col items-center gap-y-4 text-center">
              <div className="flex items-center justify-center">
                <svg
                  className="w-16 h-16 text-[#0163D0]"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={1.5}
                    d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </div>

              <div className="text-center">
                <h2 className="text-xl font-semibold text-gray-900 mb-2">
                  {t('promotion.notEligibleTitle', 'This offer isn’t available for you')}
                </h2>
                <p className="text-gray-600">
                  {t(
                    'promotion.notEligibleBody',
                    'You’re not eligible for this product, but you may be eligible for other offerings.'
                  )}
                </p>
              </div>

              <button
                onClick={onSeeOtherOfferings}
                className="mt-6 w-full h-12 bg-primary-500 text-white rounded-md text-sm font-semibold transition-colors hover:bg-primary-600 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-500"
              >
                {t('promotion.seeOtherOfferings', 'See Other Offerings')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NotEligibleForPromotionMessage
